import Login from '../pages/login';
import Landing from '../pages/landing';
import Document from '../pages/document';
import Products from '../pages/products';
import ViewClient from '../pages/viewClient';
import Inbox from '../pages/inbox';
import InboxDetails from '../pages/inboxDetails';
import Investments from '../pages/investments';
import ActivateAccount from '../pages/activateAccount'
import forget from '../pages/forget'
import LoginInformation from '../pages/loginInformation'
import home from '../pages/home'
import Profile from '../pages/profile'
import TandC from '../pages/TandC'
import PrivacyPolicy from '../pages/privacyPolicy'
import ContactUs from '../pages/contactUs'
import loginTandC from '../pages/loginTandC'
import ExitVoting from '../pages/exitVoting'
import TaxQuestionnaire from '../pages/taxQuestionnaire'
import Questionnaires from '../pages/taxQuestionnaire/questionnaires';
import BankAccount from '../pages/bankAccount'
import BankAccountForm from '../pages/bankAccount/bankAccountForm'
import ProductDetail from '../pages/products/productDetail';
import LoginAs from '../pages/login-as'
import InternalAccountActivate from '../pages/activateAccount/internal';

export const ROUTER_TABLE = [
  {
    path: '/',
    component: Landing,
    auth: true,
  },
  {
    path: '/document',
    component: Document,

  },
  {
    path: '/products',
    component: Products,
    auth: true,

  },
  {
    path: '/products/:id',
    component: ProductDetail,
    auth: true,

  },
  {
    path: '/viewClient',
    component: ViewClient,
    auth: true,

  },
  {
    path: '/landing',
    component: Landing,
    auth: true,
  },
  {
    path: '/inbox',
    component: Inbox,
    auth: true,
  },
  {
    path: '/inboxDetails',
    component: InboxDetails,
    auth: true,
  },
  {
    path: '/inboxDetails/:id',
    component: InboxDetails,
    auth: true,
  },
  {
    path: '/investments/:id/:name',
    component: Investments,
    auth: true,
  },
  {
    path: '/investments',
    component: Investments,
    auth: true
  },
  {
    path: '/activateAccount',
    component: ActivateAccount,
    auth: true
  },
  {
    path: '/loginInformation',
    component: LoginInformation,
    auth: true
  },
  {
    path: '/loginTandC',
    component: loginTandC,
    auth: true
  },
  {
    path: '/profile',
    component: Profile,
    auth: true
  },
  {
    path: '/TandC',
    component: TandC,
    auth: true
  },
  {
    path: '/PrivacyPolicy',
    component: PrivacyPolicy,
    auth: true
  },
  {
    path: '/contactUs',
    component: ContactUs,
    auth: true
  },
  {
    path: '/home',
    component: home,
    auth: true
  },
  {
    path: '/forget',
    component: forget,
    auth: true
  },
  {
    path: '/exitvoting',
    component: ExitVoting,
    auth: true
  }
  ,
  {
    path: '/taxQuestionnaire',
    component: TaxQuestionnaire,
    auth: true
  },
  {
    path: '/questionnaires',
    component: Questionnaires,
    auth: true
  },
  {
    path: '/bankAccount',
    component: BankAccount,
    auth: true
  },
  {
    path: '/bankAccountForm/:action/:syndicationCurrency',
    component: BankAccountForm,
    auth: true
  },
  {
    path: '/login-as/clients',
    component: LoginAs,
    auth: true
  },
  {
    path: '/preview/home',
    component: home,
    auth: true
  },
  {
    path: '/preview/exitvoting',
    component: ExitVoting,
    auth: true
  },
  {
    path: '/preview/bankAccount',
    component: BankAccount,
    auth: true
  },
  {
    path: '/preview/bankAccountForm/:action/:syndicationCurrency',
    component: BankAccountForm,
    auth: true
  },
  {
    path: '/preview/products',
    component: Products,
    auth: true
  },
  {
    path: '/preview/products/:id',
    component: ProductDetail,
    auth: true
  },
  {
    path: '/preview/profile',
    component: Profile,
    auth: true
  },
  {
    path: '/preview/document',
    component: Document,
    auth: true
  },
  {
    path: '/preview/investments',
    component: Investments,
    auth: true
  },
  {
    path: '/preview/inbox',
    component: Inbox,
    auth: true
  },
  {
    path: '/preview/inboxDetails/:id',
    component: InboxDetails,
    auth: true
  },
  {
    path: '/preview/contactUs',
    component: ContactUs,
    auth: true
  }
];
